import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bcb7f64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "top-container" }
const _hoisted_2 = { id: "outer-question-container" }
const _hoisted_3 = ["hidden"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "question-container" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "inner-question-container" })
], -1))
const _hoisted_6 = { id: "filter-container" }
const _hoisted_7 = { id: "filter-title-container" }
const _hoisted_8 = { id: "button-container" }
const _hoisted_9 = { class: "option-container" }
const _hoisted_10 = { for: "all-input" }
const _hoisted_11 = { class: "option-container" }
const _hoisted_12 = { for: "fully-attempted-input" }
const _hoisted_13 = { class: "input-detail" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "fully-attempted-container",
  class: "sample-container"
}, null, -1))
const _hoisted_15 = { class: "option-container" }
const _hoisted_16 = { for: "partially-attempted-input" }
const _hoisted_17 = { class: "input-detail" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "partially-attempted-container",
  class: "sample-container"
}, null, -1))
const _hoisted_19 = { class: "option-container" }
const _hoisted_20 = { for: "unattempted-input" }
const _hoisted_21 = { class: "input-detail" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "unattempted-container",
  class: "sample-container"
}, null, -1))
const _hoisted_23 = ["hidden"]
const _hoisted_24 = { for: "flagged-input" }
const _hoisted_25 = { class: "input-detail" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "flagged-container",
  class: "sample-container"
}, null, -1))
const _hoisted_27 = ["hidden"]
const _hoisted_28 = { class: "mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "review-container",
    "aria-hidden": "true",
    style: _normalizeStyle([_ctx.styleObject, { height: _ctx.displayHeight }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          id: "text-container",
          hidden: !_ctx.textAvailable
        }, [
          _createElementVNode("p", {
            innerHTML: _ctx.getText()
          }, null, 8, _hoisted_4)
        ], 8, _hoisted_3),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('btn.show')) + ": ", 1),
        _createElementVNode("form", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              id: "all-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterType) = $event)),
              type: "radio",
              name: "filtergroup",
              value: "all",
              checked: "checked"
            }, null, 512), [
              [_vModelRadio, _ctx.filterType]
            ]),
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.all')), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              id: "fully-attempted-input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterType) = $event)),
              type: "radio",
              name: "filtergroup",
              value: "fullyAttempted"
            }, null, 512), [
              [_vModelRadio, _ctx.filterType]
            ]),
            _createElementVNode("label", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('review.fully_attempted')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              id: "partially-attempted-input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterType) = $event)),
              type: "radio",
              name: "filtergroup",
              value: "partiallyAttempted"
            }, null, 512), [
              [_vModelRadio, _ctx.filterType]
            ]),
            _createElementVNode("label", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('review.partial_attempted')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              id: "unattempted-input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterType) = $event)),
              type: "radio",
              name: "filtergroup",
              value: "unattempted"
            }, null, 512), [
              [_vModelRadio, _ctx.filterType]
            ]),
            _createElementVNode("label", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('review.unattempted')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", {
            hidden: !_ctx.flagItemEnabled,
            class: "option-container"
          }, [
            _withDirectives(_createElementVNode("input", {
              id: "flagged-input",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterType) = $event)),
              type: "radio",
              name: "filtergroup",
              value: "flagged"
            }, null, 512), [
              [_vModelRadio, _ctx.filterType]
            ]),
            _createElementVNode("label", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('review.flagged')), 1)
              ])
            ])
          ], 8, _hoisted_23)
        ])
      ])
    ]),
    _createElementVNode("div", {
      id: "toolbar-container",
      hidden: _ctx.testReviewDisplayStrategy.isScreenDisplay()
    }, [
      (_openBlock(), _createElementBlock("button", {
        id: "submit-button",
        key: _ctx.iconAfterNext,
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitButtonClicked && _ctx.submitButtonClicked(...args)))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(_ctx.iconBeforeNext)
        }, null, 2),
        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.submitButtonText), 1),
        _createElementVNode("i", {
          class: _normalizeClass(_ctx.iconAfterNext)
        }, null, 2)
      ]))
    ], 8, _hoisted_27)
  ], 4))
}